module.exports = __webpack_public_path__ + "img/munich-startup.2ddec4b1.png";